/**
 * RFC 9457 problem documents, which every API error uses.
 *
 * Not generated: the error responses are built by hand on the server and do
 * not appear in the OpenAPI components. The shape is stable and small enough
 * to state here, and `asProblem` never throws, so an error path cannot itself
 * become an error.
 */
export interface Problem {
  type: string
  title: string
  status: number
  detail: string
  instance?: string
  trace_id?: string
  errors?: { loc: (string | number)[]; msg: string; type: string }[]
}

const GENERIC: Problem = {
  type: 'about:blank',
  title: 'Something went wrong',
  status: 0,
  detail: 'The request failed before the server could answer.',
}

export function asProblem(value: unknown, status = 0): Problem {
  if (value && typeof value === 'object' && 'title' in value && 'detail' in value) {
    return value as Problem
  }
  return { ...GENERIC, status }
}

/** Thrown by the query helpers so React Query's error branch has the detail. */
export class ApiError extends Error {
  readonly problem: Problem

  constructor(problem: Problem) {
    super(problem.detail)
    this.name = 'ApiError'
    this.problem = problem
  }
}
